import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSortModule } from '@angular/material/sort';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ManagementRoutingModule } from './management-routing.module';
import { SharedModule } from '@shared';
import { MaterialModule } from '@core';
import {
  AnnualCapComponent,
  DeductibleComponent,
  ExclusionsComponent,
  PreferredMedicationListComponent,
  CoPayScheduleComponent,
  BenefitFormComponent,
  OnlineEligibilityModule,
  SidebarComponent,
  RequestIdCardComponent,
  AuditLogsComponent,
  ClaimSearchComponent,
  DashboardComponent,
} from '@management';
@NgModule({
  declarations: [
    DashboardComponent,
    CoPayScheduleComponent,
    SidebarComponent,
    AnnualCapComponent,
    DeductibleComponent,
    ExclusionsComponent,
    PreferredMedicationListComponent,
    BenefitFormComponent,
    AuditLogsComponent,
    RequestIdCardComponent,
    ClaimSearchComponent,
  ],
  imports: [
    CommonModule,
    ManagementRoutingModule,
    FormsModule,
    SharedModule,
    MaterialModule,
    OnlineEligibilityModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    NgxMatSelectSearchModule,
    MatSortModule,
  ],
})
export class ManagementModule {}
